export const generateNextID = ({list}) => {
  const max_id_from_list =
    list?.length > 0 ? Math.max(...list?.map(li => li.id)) : 0;

  return max_id_from_list + 1;
};
